// Guarantee check (docs/mastermind-admin-plan.md 3.3; named so by Adam's answer of 20 Oct to the build plan's question
// 3), folded, for owner and admin only and never on the log: a verdict first ("Doesn't meet the guarantee so far:
// actions 50% done, 80% needed"), then each of the 4 measures as it stands for the end of the term, each linked to its
// proof on the page, and when the term ends and extension claims close (30 days after), with any paused days added.
// It opens by itself in the term's last 2 months, and from the head's More menu (the critique's admin 11).
import { Card } from '../ui/index.js'
import { dmy, spanWords } from '../../products/mastermind/log.js'
import { MM } from './words.js'
import { termOpens, termVerdict } from './section.js'
import { openAt } from './Fold.jsx'

const DAY = 86400000

// The goal's line: whether it was agreed within its days (yes, no, or not judged when they ended before the hub kept
// the record), whether or not it has since been reached
function goalLine(go, days) {
  if (go.state === 'reached') {
    const agreed = go.agreed_on ? dmy(go.agreed_on) : ''
    if (go.judged === false) return MM.termGoal.reachedUnjudged(days, agreed, dmy(go.reached_on))
    if (go.agreed_on && (go.days_after ?? 0) > days) return MM.termGoal.reachedLate(days, agreed, dmy(go.reached_on))
    return MM.termGoal.reached(days, dmy(go.reached_on))
  }
  const g = MM.termGoal[go.state] || MM.termGoal.not_yet
  return g(days, go.agreed_on ? dmy(go.agreed_on) : go.due_on ? dmy(go.due_on) : '')
}

// The lines under the verdict: [{ text, target }], target the card on the page that holds its proof
export function termLines(log) {
  const sum = log.summary || {}
  const rules = log.rules || {}
  const months = log.product?.term_months || 12
  const go = sum.goal || {}
  const days = go.days ?? rules.goal_days ?? 30
  const lines = [
    { text: goalLine(go, days), target: '#mm-goal' },
    { text: MM.termSessions(sum.sessions?.missed || 0, sum.sessions?.limit ?? rules.absence_limit ?? 2), target: '#mm-sessions' },
    { text: MM.termActions(sum.actions?.finished ? sum.actions.pct : null, sum.actions?.needed ?? rules.actions_pct ?? 80), target: '#mm-earlier' },
    {
      text: (sum.membership?.suspended || []).length
        ? MM.termMemberSusp((sum.membership.suspended || []).map(spanWords).join(' and '))
        : MM.termMemberNone(rules.kept_since ? dmy(rules.kept_since) : null),
      target: null,
    },
  ]
  const term = log.term || {}
  if (term.term_end) {
    const end = Date.parse(term.term_end)
    lines.push({ text: MM.termEnd(dmy(term.term_end), term.paused_days || 0, dmy(new Date(end + 30 * DAY).toISOString())), target: null })
  } else lines.push({ text: MM.termRunning(months), target: null })
  return lines
}

export function TermCard({ log }) {
  const verdict = termVerdict(log)
  return (
    <Card className="amx-term" body={false} labelledBy="mm-term-h">
      <details className="amx-fold" open={termOpens(log) || undefined}>
        <summary className="amx-fold-head"><h2 className="ad-card-title" id="mm-term-h">{MM.termH()}</h2></summary>
        <p className={`amx-term-verdict${verdict.meets === false ? ' amx-term-verdict--short' : ''}`}>{verdict.text}</p>
        <ul className="amx-term-list">
          {termLines(log).map(l => <li key={l.text}>{l.target ? <a href={l.target} onClick={() => openAt(l.target)}>{l.text}</a> : l.text}</li>)}
        </ul>
      </details>
    </Card>
  )
}
